import Vue from 'vue';
import Vuex from 'vuex';
// import keys from './keys'
import * as snackbar from './snackbar'
import * as auth from './auth'
import * as drawer from './drawer'
import * as secondary_drawer from './secondary-drawer'
import * as shipment from './shipment'
import * as withdrawal from './withdrawal'
import * as user_subscription from './user-subscription'
import * as payout from './payout'
import * as team from './team'
import * as dispatch_history from './dispatch-history'
import * as retailers from './retailers'
import * as initiate_withdrawal from './initiate_withdrawal'
import keys from "../keys.js"

Vue.use(Vuex);

export const store = new Vuex.Store({

    modules: {
        snackbar,
        auth,
        drawer,
        secondary_drawer,
        shipment,
        withdrawal,
        user_subscription,
        payout,
        team,
        dispatch_history,
        retailers,
        initiate_withdrawal,
    },
    state: {
        is_production: true,
        page_loader: false,
        otp_token: "",
        otp_medium: "",
        // token:localStorage.getItem("token") || null,
        token: sessionStorage.getItem("token") || null,
        user_type: sessionStorage.getItem("user_type") || null,
        // user_type:localStorage.getItem("user_type") || null,
        warehouse: JSON.parse(localStorage.getItem('warehouse')) || null,
        retailer: null,
        wallet_filter_dialog: false,
        welcome_dialog: false,
        image_viewer: false,
        polling_interval: 180000,
        shipment_filter_count: 0,
        new_notification_count: 0,
        map_center: {
            lat: 21.2514,
            lng: 81.6296,
        },
    },
    categories: [],
    getters: {
        getOtpToken: state => {
            return state.otp_token;
        },
        getUsertype: state => {
            return state.user_type;
        },
        getOtpMedium: state => {
            return state.otp_medium;
        },
        getRetailer: state => {
            return state.retailer;
        },
        getPaytmMid: state => {
            if (state.is_production)
                return keys.PRODUCTION_PAYTM_MID
            else
                return keys.STAGING_PAYTM_MID
        },
        getPaytmUrl: state => {
            if (state.is_production)
                return keys.PRODUCTION_PAYTM_PG_URL
            else
                return keys.STAGING_PAYTM_PG_URL
        },
    },
    mutations: {
        SET_USER_TYPE(state, value) {
            state.user_type = value
        },
        SET_OTP_TOKEN(state, value) {
            state.otp_token = value
        },
        SET_OTP_MEDIUM(state, value) {
            state.otp_medium = value
        },
        SET_WHAREHOUSE(state, value) {
            state.warehouse = value
        },
        SET_RETAILER(state, value) {
            state.retailer = value
        },
        SET_WALLET_FILTER_DIALOG(state, value) {
            state.wallet_filter_dialog = value
        },
        SET_PAGE_LOADER(state, value) {
            state.page_loader = value
        },
        SET_WELCOME_DIALOG(state, value) {
            state.welcome_dialog = value
        },
        SET_IMAGE_VIEWER(state, value) {
            state.image_viewer = value
        },
        SET_MAP_CENTER(state, {lat, lng,}) {
            state.map_center.lat = lat
            state.map_center.lng = lng
        },
        SET_NEW_NOTIFICATION_COUNT(state, value) {
            state.new_notification_count = value
        },
    },
    actions: {
        setUserType({commit}, value) {
            commit('SET_USER_TYPE', value)
        },
        setOtpToken({commit}, value) {
            commit('SET_OTP_TOKEN', value)
        },
        setOtpMedium({commit}, value) {
            commit('SET_OTP_MEDIUM', value)
        },
        setWarehouse({commit}, value) {
            commit('SET_WHAREHOUSE', value)
        },
        setRetailer({commit}, value) {
            commit('SET_RETAILER', value)
        },
        setWalletFilterDialog({commit}, value) {
            commit('SET_WALLET_FILTER_DIALOG', value)
        },
        setPageLoader({commit}, value) {
            commit('SET_PAGE_LOADER', value)
        },
        setWelcomeDialog({commit}, value) {
            commit('SET_WELCOME_DIALOG', value)
        },
        setImageViewer({commit}, value) {
            commit('SET_IMAGE_VIEWER', value)
        },
        setMapCenter({commit}, value) {
            // console.log("value")
            // console.log(value)
            commit('SET_MAP_CENTER', value)
        },
        setNewNotificationCount({commit}, value) {
            commit('SET_NEW_NOTIFICATION_COUNT', value)
        },
    }
});


	